import { StorageResource } from "../../../../infrastructure/StorageResource";

const themeStorageResource = new StorageResource('@themes');

export default themeStorageResource;


// WEBPACK FOOTER //
// ./src/app/modules/stickers/domain/resources/ThemeStorageResource.ts